import {useCallback, useState} from 'react';

export function useCopyToClipboard(resetDelay = 1500): [boolean, (text: string) => void] {
    const [copied, setCopied] = useState(false);

    const copy = useCallback((text: string) => {
        const finish = () => {
            setCopied(true);
            setTimeout(() => setCopied(false), resetDelay);
        };

        if (navigator.clipboard) {
            navigator.clipboard.writeText(text).then(finish);
        } else {
            const el = document.createElement('textarea');
            el.textContent = text;
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            el.remove();
            finish();
        }
    }, [resetDelay]);

    return [copied, copy];
}
